<template>
    <div>
        <p class="mt-4">
            <strong>Send During Hours ({{send_during_timezone}})</strong>
        </p>
        <m-daily-schedule
            :value="template.send_during"
            :read_only="read_only"
            @input="onInput"
        />
    </div>
</template>

<script>
export default {
    props: {
        template: {
            type: Object,
            required: true
        },
        send_during_timezone: {
            type: String,
            default: ''
        },
        read_only: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        onInput(value) {
            this.$emit('input', value);
        }
    }
}
</script>
